import { Button } from '@/components/common/button'
import { Note } from '@/components/common/note'
import { ErrorIcon } from '@/components/icons/error'

interface DepositLimitWarningProps {
  depositLimitValue: string
  assetSymbol: string
  actionLabel?: string
  onClick: () => void
}

export function DepositLimitWarning({
  depositLimitValue,
  assetSymbol,
  actionLabel = 'Deposit',
  onClick,
}: DepositLimitWarningProps) {
  return (
    <Note color="red">
      <div className="flex items-center gap-2">
        <ErrorIcon />
        <h6 className="font-bold">Supply cap is exceeded</h6>
      </div>
      <div className="inline-block text-xs">
        <p className="inline">
          Maximum available to supply due to current supply cap: {depositLimitValue} {assetSymbol}. This value may
          change over time.
        </p>{' '}
        <Button variant="default" size="default" className="inline w-fit text-xs underline" onClick={onClick}>
          {actionLabel} {depositLimitValue} {assetSymbol} instead
        </Button>
      </div>
    </Note>
  )
}
